export enum LifetimeState {
  New,
  PoweredUp,
  FirmwareInstalled,
  KeysInstalled,
  AssignedToAsset,
  InstalledOnAsset,
  Unknown,
}
